<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> Customers for Letter Number '{{inner_Letter.code}}' </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="openModal_Customer(templateCustomer)" class="btn btn-success" style="margin-right: 5px;"> Search Customers
          <i class="fa fa-vcard"></i> </button>
          <button (click)="OnSet_Back_LetterrequestcustomerRelativeList()" type="button" class="btn btn-warning"><i
            class="fa fa-mail-reply"></i>
          Back </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerRelative
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_LetterrequestcustomerRelative.length
                      }
            ">
              <td>{{DataList_LetterrequestcustomerRelative.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <button type="button" (click)="DeleteData(item)" class="btn btn-danger"> Delete
                  <i class="fa fa-remove"></i> </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>



<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Behfa Customer Code</th>
              <th>Customer Name</th>
              <th>Customer Name (English)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td>{{item.name_en}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>
